module.exports = __webpack_public_path__ + "media/promo/promo/images/mob-2-ad64c9c47f9a4a425b27f3b367d5bac5.png";